import React from 'react';
import { Link } from 'react-router-dom';
import { FiCompass } from 'react-icons/fi';

export default function NotFound() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--content-bg)' }}>
      <div style={{ textAlign: 'center' }}>
        <FiCompass style={{ fontSize: 64, color: 'var(--primary)', marginBottom: 16 }} />
        <h1 style={{ fontSize: 48, fontWeight: 800 }}>404</h1>
        <p style={{ color: 'var(--text-muted)', marginBottom: 20 }}>The page you are looking for doesn't exist.</p>
        <Link to="/" className="btn btn-primary">Back to Dashboard</Link>
      </div>
    </div>
  );
}